import { ref } from 'vue';
import MetricaAiProviderConfigAPI from 'dashboard/api/metrica/aiProviderConfig';

// Shared "is AI configured" state (Prime Insight — Configuração de IA).
// Fetched once per dashboard mount, same singleton-ref pattern as
// useMetricaAccess.js, so every consumer (warning banners across ~9 screens,
// the reply-box AI button, the conversation analysis panel) just reads
// capabilities.value.chat/etc. instead of each doing its own fetch/parse.
const loaded = ref(false);
const anyConfigured = ref(false);
const capabilities = ref({
  chat: false,
  transcription: false,
  image: false,
  document: false,
});
const raw = ref(null);

export function useMetricaAiConfig() {
  const fetchAiConfig = async () => {
    try {
      const { data } = await MetricaAiProviderConfigAPI.show();
      raw.value = data;
      anyConfigured.value = (data.providers || []).some(p => p.connected);
      const next = {
        chat: false,
        transcription: false,
        image: false,
        document: false,
      };
      (data.capabilities || []).forEach(c => {
        next[c.key] = Boolean(c.configured);
      });
      capabilities.value = next;
    } catch {
      // Never block the app on a status-fetch failure — same invariant as
      // useMetricaAccess.
      anyConfigured.value = false;
    } finally {
      loaded.value = true;
    }
  };

  return { loaded, anyConfigured, capabilities, raw, fetchAiConfig };
}
